export const OPEN = 'OPEN'
export const ONGOING = 'ONGOING'
export const OUTDATED = 'OUTDATED'
